import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigFormScreen } from './ConfigFormScreen';
import { useOgTopup, useUpdateOgTopup } from '@/api/opengater/useSettings';
/** users `admin: topup-settings` — min/max top-up amounts (RUB). */
export function OpengaterTopup() {
    const q = useOgTopup();
    const upd = useUpdateOgTopup();
    return (_jsx(ConfigFormScreen, { title: "\u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435", subtitle: "\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0438 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0431\u0430\u043B\u0430\u043D\u0441\u0430", capability: "topup-settings.write", sections: [
            {
                fields: [
                    { key: 'min_amount_rub', label: 'Минимум, ₽', kind: 'money' },
                    { key: 'max_amount_rub', label: 'Максимум, ₽', kind: 'money' },
                ],
            },
        ], data: q.data, isLoading: q.isLoading, error: q.error, saving: upd.isPending, saveError: upd.error, saved: upd.isSuccess, onSave: (patch) => upd.mutate(patch), onResetFeedback: upd.reset }));
}
